/* PDP clone kit – main product section: the gallery (thumbnail row and arrows that go round, like the original) and
   the video row under it (its arrows are the shared pdp-carousel in pdp-core.js; play / pause is pdp-video.js); the
   bundle area is pdp-offers.js. IntersectionObserver instead of scroll listeners. */
(function () {
  'use strict';
  var PDP = window.PDP || {};
  var define = PDP.define || function (n, c) { if (window.customElements && !customElements.get(n)) customElements.define(n, c); };
  var reduceMotion = !!PDP.reduceMotion;
  var hasIO = 'IntersectionObserver' in window;

  define('pdp-gallery', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this._ready) return;
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this._ready = true;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.pdp-gallery__slide'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.thumbWrap = this.querySelector('[data-thumbs]');
      this.index = 0;
      this._lockUntil = 0;
      var n = this.slides.length;
      this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.goTo(parseInt(t.dataset.thumb, 10)); }); });
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo((self.index - 1 + n) % n); });
      if (next) next.addEventListener('click', function () { self.goTo((self.index + 1) % n); });
      if (hasIO && n > 1) {
        this._io = new IntersectionObserver(function (entries) {
          if (Date.now() < self._lockUntil) return;
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) self.setActive(parseInt(en.target.dataset.index, 10));
          });
        }, { root: this.track, threshold: [0.6] });
        this.slides.forEach(function (s) { self._io.observe(s); });
      }
    }
    disconnectedCallback() { if (this._io) this._io.disconnect(); }
    setActive(i) {
      if (i === this.index && this._set) return;
      this._set = true;
      this.index = i;
      this.slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      this.thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      // keep the active thumbnail in view inside its own row (never scrolls the page)
      var thumb = this.thumbs[i], wrap = this.thumbWrap;
      if (thumb && wrap && wrap.scrollWidth > wrap.clientWidth + 2) {
        var left = thumb.offsetLeft - wrap.offsetLeft, right = left + thumb.offsetWidth;
        if (left < wrap.scrollLeft || right > wrap.scrollLeft + wrap.clientWidth) wrap.scrollTo({ left: Math.max(0, right - wrap.clientWidth), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    goTo(i) {
      var slide = this.slides[i];
      if (!slide) return;
      this._lockUntil = Date.now() + 700;
      this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.setActive(i);
    }
  });

})();
